(function (doc, win) {
  let docEl = doc.documentElement
  let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  let recalc = function () {
    var clientWidth = docEl.clientWidth
    if (!clientWidth) return
    docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)
/* 设计搞如果是750px。那么(clientWidth(设备的宽度) / 375) 这里除的就是375或750.那么1rem就是100px或50px  width=3.75rem或7.5rem就可以铺满整个屏幕了 */



// WEBPACK FOOTER //
// ./src/utils/rem.js